export const videoDescriptionMap: Record<string, string> = {};
export const videoMetaMap: Record<
  string,
  { videoId?: string; contentTitle?: string; liveStreamStatus?: string }
> = {};

import { dlEventConstants } from "@repo/analytics/data-layer.constants";
import type { VideoDetails } from "./storyBlockTypes";

export function statMapper(eventType: string): string | null {
  const map: Record<string, string> = {
    "fw:shopping:product-clicked": dlEventConstants.PRODUCT_CTA,
    "fw:shopping:product-card-clicked": dlEventConstants.PRODUCT_CTA,
    "fw:shopping:pdp-primary-cta-clicked": dlEventConstants.PRODUCT_CTA,
    "fw:shopping:pinned-product-clicked": dlEventConstants.PRODUCT_CTA,
    "fw:shopping:product-list-item-clicked": dlEventConstants.PRODUCT_CTA,
    "fw:video:click-cta": dlEventConstants.CLICK_CTA,
    "fw:storyblock:thumbnail-click": dlEventConstants.THUMBNAIL_CLICK,
    "fw:player:transition": dlEventConstants.VIDEO_PLAY,
  };
  return map[eventType] || null;
}

export const FW_PRODUCT_CLICK_EVENTS = ["fw:shopping:product-clicked"] as const;

export const STORYBLOCK_EVT_LOG = "[STORYBLOCK_EVT]";

export function resolveVideoDescription(
  videoDetails?: VideoDetails,
  fallbackVideoId?: string
): string {
  return (
    videoDetails?.video?.description ||
    videoDetails?.video?.event_description ||
    (fallbackVideoId ? videoDescriptionMap[fallbackVideoId] : undefined) ||
    "NA"
  );
}

export const FW_EVENT_TO_CTA_TEXT: Record<string, string> = {
  "fw:video:play": "WATCHNOW",
  "fw:video:pause": "PAUSE",
  "fw:video:mute": "MUTE",
  "fw:video:unmute": "UNMUTE",
  "fw:video:fullscreen": "FULLSCREEN",
  "fw:player:minimize": "PIP_IN",
  "fw:player:maximize": "PIP_OUT",
  "fw:video:click-cta": "CLICK_CTA",
  "fw:storyblock:thumbnail-click": "THUMBNAIL_CLICK",
  "fw:shopping:product-clicked": "PRODUCT_CLICK",
  "fw:shopping:product-card-clicked": "PRODUCT_CLICK",
  "fw:shopping:pdp-primary-cta-clicked": "PRODUCT_CLICK",
  "fw:shopping:pinned-product-clicked": "PRODUCT_CLICK",
  "fw:shopping:product-list-item-clicked": "PRODUCT_CLICK",
};

export function getCtaTextForStoryBlock(eventType?: string, videoDetails?: VideoDetails): string {
  if (eventType === "fw:player:transition") {
    if (videoDetails?.transitionTo === "minimized") {
      return "PIP_IN";
    }
    if (videoDetails?.transitionTo === "fullscreen") {
      return "PIP_OUT";
    }
  }

  return FW_EVENT_TO_CTA_TEXT[eventType || ""] || "WATCHNOW";
}
